export const RELATIVE_TIME_REFRESH_MS = 60000;
